import { useParams } from 'react-router';
import AdminLayout from "./AdminLayout";
import { FaArrowLeft, FaCheck  } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import ApplicationOne from "./Tables/ApplicationOne";
import ApplicationTwo from "./Tables/ApplicationTwo";
import ApplicationThree from "./Tables/ApplicationThree";
import { useEffect, useState } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import CustomizedSnackbars from "../../Feedback";
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { reviewApplicationAction } from '../../../Firebase/actions/reviewApplicationAction';
import { Link, Redirect } from 'react-router-dom';
import { declineApplicationAction } from '../../../Firebase/actions/declineApplicationAction';

const AdmissionAdmin = ({ applications, reviewApplicationAction, declineApplicationAction,reviewSuccess, reviewError, declineApplicationSucess, declineApplicationError, resetAccept, resetDecline }) => {
    const { id } = useParams();

    const [ programme, setProgramme ] =  useState('');
    const [ classCode, setClassCode] = useState('');
    const [ error, setError] = useState(null);
    const [ division, setDivision ] = useState('');

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const [success, setSuccess ] = useState(false);

    let application;
    let data;

    if (applications) {

        application = applications.filter((application) => {
            return application.id === id
        });    
        data = application[0];
        //console.log(data);
    }

    const handleAccept = () => {
        if(classCode === '') {
            setError('Please select a class.');
        } else {
            setError(null);
            // if(programme === 'Music' || programme === 'Cosmetology' || programme === 'Art and Design' || programme === 'Fashion Design' || programme === 'Clothing' ) {
            //     setDivision('Applied Art');
            // } else if (programme === 'Science Technology' || programme === 'Horticulture') {
            //     setDivision('Applied Science');
            // } else if (programme === 'Food and Beverage Service' ||  programme === 'Bakery Studies' ||  programme === 'Tourism and Hospitality Management' ||  programme === 'Professional Cookery' ) {
            //     setDivision('Hospitality');
            // } else if (programme === 'Brick and Block Laying' || programme === 'Painting and Decorating' || programme === 'Plumbing and Drain Laying' || programme === 'Carpentry and Joinery' || programme === 'Wood Machines and Manufacturing' || programme === 'Construction Technology' ) {
            //     setDivision('Construction and Wood Technology');
            // } else if (programme === 'Civil Engineering' || programme === 'Quantity Surveying Engineering' || programme === 'Water Resources and Irrigation Engineering') {
            //     setDivision('Civil Engineering');
            // } else if (programme === 'Motor Vehicle Body Repairs + Refinishing' || programme === 'Motor Vehicle Mechanics' || programme === 'Automobile Electrics and Electronics' ) {
            //     setDivision('Automotive');
            // } else if(programme === 'Electrical Power' || programme === 'Computer Systems' ||  programme === 'Communication Systems' ) {
            //     setDivision('Electrical');
            // } else if ( programme === 'Diesel Plant Fitting' ||  programme === 'Fabrication Engineering' ||  programme === 'Machine Shop Engineering' || programme === 'Refrigeration and Air Conditioning' || programme === 'Production Engineering' || programme === 'Mechanical Engineering')  {
            //     setDivision('Mechanical');
            // } else if ( programme === 'Accountancy' || programme === 'Banking and Finance' ) {
            //     setDivision('Business Studies');
            // } else if ( programme === 'Transport and Logistics Management' ||  programme === 'Marketing Management' || programme === 'Human Resources' || programme === 'Purchasing and Supply' ) {
            //     setDivision('Management Studies');
            // } else if (programme === 'Secretarial' || programme === 'Office Management') {
            //     setDivision('Office Management');
            // } else if (programme === 'Information Technology' || programme === 'Library and Information Science' || programme === 'Records Management and Info Science') {
            //     setDivision('IM Systems');
            // }  else if (programme === 'Further Education Trainers Certificate' || programme === 'Further Education Trainers Diploma') {
            //     setDivision('Education');
            // }
            
            let data =  {
                division,
                programme,
                classCode,
                id
            }
            document.querySelector('#Btn1').classList.add('is-loading');
            
            // Step One : 
            //add the info to students db
            //console.log(data)
            reviewApplicationAction(data);

        }
    }
    const handleDecline = () => {
        //delete the document from the applications collection
        declineApplicationAction(id);
        //and return to prev page

        //nofication
        //on error
        setFeedbackText('Application declined');
        setSeverity('error');
        setOpenFeedback(true);
    }

    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });

        if(reviewSuccess) {
            //on success
            setFeedbackText('Application status updated to accepted.');
            setSeverity('success');
            setOpenFeedback(true);
            document.querySelector('#Btn1').classList.remove('is-loading');
            setSuccess(true);

            resetAccept();
        }

        if(declineApplicationSucess) {
            //on success
            setFeedbackText('Application deleted.');
            setSeverity('success');
            setOpenFeedback(true);
            document.querySelector('#Btn1').classList.remove('is-loading');
            
            resetDecline();
            <Redirect to="/admin-applications" />
            
        }

        if(reviewError) {
            //on error
            document.querySelector('#Btn1').classList.remove('is-loading');
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);
        }

        if(declineApplicationError) {
            //on error
            document.querySelector('#Btn1').classList.remove('is-loading');
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);
        }

    }, [reviewError, reviewSuccess, declineApplicationError, declineApplicationSucess, resetAccept, resetDecline]);

    return ( 
        <AdminLayout>
            <div className="row pt-4">
                {
                    data && (
                        <div className="col s12 m10 l9 offfset-m1 offset-l1">
                            <h5 className="title is-size-5-touch has-text-weight-semibold mt-6 mb-2 grey-text text-darken-3">Application</h5>
                            <div className="divider mb-5"></div>
                                                 
                            <h5 className="is-size-5 has-text-weight-semibold mt-6 mb-4 grey-text text-darken-3">Personal Information</h5>
                            <div className="white smooth-edge-2 pl-2 row pt-5 pb-2">
                                <div className="col s12 m4 mb-3">
                                    <span>{data.title} {data.forenames} {data.surname}</span>
                                </div>
                                <div className="col s12 m4 mb-4">
                                    <span>{data.dob}</span>
                                </div>
                                <div className="col s12 m4 mb-4">
                                    <span>{data.gender}</span>
                                </div>
                                <div className="col s12 m4 mb-4">
                                    <span>{data.maritalStatus}</span>
                                </div>
                                <div className="col s12 m4 mb-4">
                                    <span>{data.idNumber}</span>
                                </div>
                                <div className="col s12 m4 mb-4">
                                    <span>Place of Birth: {data.placeOfBirth}</span>
                                </div>
                                <div className="col s12 m4 mb-4">
                                    <span>Nationality: {data.nationality}</span>
                                </div>
                                <div className="col s12 m4 mb-4">
                                    <span>Citizenship: {data.citizenship}</span>
                                </div>
                                <div className="col s12 m4 mb-4">
                                    <span>{data.email}</span>
                                </div>
                                <div className="col s12 m4 mb-4">
                                    <span>{data.phoneNumber}</span>
                                </div>
                                <div className="col s12 m6 mb-4">
                                    <span>{data.address}</span>
                                </div>
                            </div>
                            <h5 className="is-size-5 has-text-weight-semibold mt-6 grey-text text-darken-3">O' level Examinations</h5>   
                            <ApplicationOne ordLevel={data.ordLevel}/>  
                            {
                                data.tertiary && (
                                    <>
                                        {
                                            data.tertiary.length !== 0 && (
                                                <>
                                                    <h5 className="is-size-5 has-text-weight-semibold mt-6 grey-text text-darken-3">College Examination Results</h5>
                                                    <ApplicationTwo tertiary={data.tertiary} />  
                                                </>
                                            )
                                        }

                                    </>
                                )
                            }  
                            {
                                data.work && (
                                    <>
                                        {
                                            data.work.length !== 0 && (
                                                <>
                                                    <h5 className="is-size-5 has-text-weight-semibold mt-6 grey-text text-darken-3">Work / Employment</h5>
                                                    <ApplicationThree work={data.work} /> 
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }        
                            <div className="button is-info is-small my-5">
                                <a href={data.uploadedFileUrl} target="_blank" rel="noreferrer" className="white-text">Open Scanned Documenets</a>
                            </div>
                            <div className="row">
                                <div className="input-field col s12 m6 l4">
                                    <select onChange={(e) => setProgramme(e.target.value)} value={programme} >
                                        <option value="" disabled selected>Select</option>
                                        <option value={data.programme1}>{data.programme1}</option>
                                        <option value={data.programme2}>{data.programme2}</option>
                                        <option value={data.programme3}>{data.programme3}</option>
                                    </select>
                                    <label>Applicant's Choices: </label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field col s12 m4 ">
                                    <select onChange={(e) => setDivision(e.target.value)} value={division}>
                                        <option value="" disabled>Select</option>
                                        <option value="Applied Art">Applied Art</option>
                                        <option value="Applied Science">Applied Science</option>
                                        <option value="Hospitality">Hospitality</option>
                                        <option value="Construction and Wood Technology">Construction and Wood Technology</option>
                                        <option value="Civil Engineering">Civil Engineering</option>
                                        <option value="Automotive">Automotive</option>
                                        <option value="Electrical">Electrical</option>
                                        <option value="Mechanical">Mechanical</option>
                                        <option value="Business Studies">Business Studies</option>
                                        <option value="Management Studies">Management Studies</option>
                                        <option value="Office Management">Office Management</option>
                                        <option value="IM Systems">IM Systems</option>
                                        <option value="Education">Education</option>
                                   
                                    </select>
                                    <label>Select Division: </label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field col s12 m4 ">
                                    <select onChange={(e) => setClassCode(e.target.value)} value={classCode}>
                                        <option value="" disabled>Select</option>
                                        <option value="CV082021 NC1">CV082021 NC1</option>
                                        <option value="CV082021 NC2">CV082021 NC2</option>
                                        <option value="CV012022 NC3">CV012022 NC3</option>
                                        <option value="CV012022 NC4">CV012022 NC4</option>
                                        <option value="CV012022 NC5">CV012022 NC5</option>
                                        <option value="QS082021 NC1">QS082021 NC1</option>
                                        <option value="QS012022 NC2">QS012022 NC2</option>
                                        <option value="QS012022 NC3">QS012022 NC3</option>
                                        <option value="ARC082021 NC1">ARC082021 NC1</option>
                                        <option value="ARC012022 NC2">ARC012022 NC2</option>
                                        <option value="ARC012022 NC3">ARC012022 NC3</option>
                                        <option value="VAL012022 NC1">VAL012022 NC1</option>
                                        <option value="VAL012022 NC2">VAL012022 NC2</option>
                                        <option value="IRR012022 NC1">IRR012022 NC1</option>
                                        <option value="SG012022 NC1">SG012022 NC1</option>
                                        <option value="SG012022 NC2">SG012022 NC2</option>
                                        <option value="UB012022 NC1">UB012022 NC1</option>
                                        <option value="UB012022 NC2">UB012022 NC2</option>
                                        <option value="IT012022 NC1">IT012022 NC1</option>
                                        <option value="IT012022 NC2">IT012022 NC2</option>
                                        <option value="PS012022 NC1">PS012022 NC1</option>
                                        <option value="PS012022 NC2">PS012022 NC2</option>
                                        <option value="TM012022 NC1">TM012022 NC1</option>
                                        <option value="TM012022 NC2">TM012022 NC2</option>
                                        <option value="RM012022 NC1">RM012022 NC1</option>
                                        <option value="RM012022 NC2">RM012022 NC2</option>
                                        <option value="SS012022 NC1">SS012022 NC1</option>
                                        <option value="SS012022 NC2">SS012022 NC2</option>
                                        <option value="MM012022 NC1">MM012022 NC1</option>
                                        <option value="MM012022 NC2">MM012022 NC2</option>
                                    </select>
                                    <label>Select Code: </label>
                                </div>
                            </div>
                            {
                                error && <p className="red-text text-darken-3">{error}</p>
                            }
                            {
                                success ? (
                                    <div className="container center">
                                        <div className="control mb-4">
                                            <Link to="/admin-applications" className="button is-rounded main-color mt-3 mb-4">
                                                <span className="icon">
                                                    <FaArrowLeft color="white"/>
                                                </span>
                                                <span className="white-text">Back</span>
                                            </Link>
                                        </div>
                                    </div>  
                                ) : (
                                    <div className="my-4 field is-grouped">
                                            <div className="control">
                                                <div
                                                    className="button is-danger mt-3"
                                                    onClick={handleDecline}
                                                >
                                                    <span className="icon">
                                                        <ImCross color="white"/>
                                                    </span>
                                                    <span className="white-text">Decline</span>
                                                </div>
                                            </div>
                                        
                                            <div className="control" id="Btn1">
                                                <div
                                                    className="button is-success mt-3"
                                                    onClick={handleAccept}
                                                >
                                                    <span className="icon">
                                                        <FaCheck color="white"/>
                                                    </span>
                                                    <span className="white-text">Accept</span>
                                                </div>
                                            </div>            
                                        </div>
                                )
                            }
                        </div>

                    )
                }
                {
                    !data && (
                        <div className="container center">
                            <div 
                                style={{
                                    display: 'grid',
                                    alignContent: 'center',
                                    minHeight: '80vh'
                                }}
                            >
                                <div className="control mb-6">
                                    <Link to="/admin-applications" className="button is-rounded is-success mt-3 mb-4">
                                        <span className="icon">
                                            <FaArrowLeft color="white"/>
                                        </span>
                                        <span className="white-text">Back To Applications</span>
                                    </Link>
                                </div>
                            </div>
                        </div>  

                    )
                }
            </div>
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </AdminLayout>
     );
}



const mapStateToProps = (state) => {
    //console.log(state);
    return {
        applications: state.firestore.ordered.applications,
        reviewSuccess: state.reviewApplication.reviewSuccess,
        reviewError: state.reviewApplication.reviewError,
        declineApplicationSucess: state.declineApplication.declineApplicationSucess,
        declineApplicationError: state.declineApplication.declineApplicationError
    };
};
 

const mapDispatchToProps = (dispatch) => {
    return {
        reviewApplicationAction: (data) => dispatch(reviewApplicationAction(data)),
        declineApplicationAction: (id) => dispatch(declineApplicationAction(id)),
        resetAccept: () => dispatch({ type: "ACCEPTED_REVIEW", success: false }),
        resetDecline: () => dispatch({ type: "DELETE_APPLICATION", success: false })

    };
};
  
 
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "applications", 
            },
    ])
)(AdmissionAdmin);